import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['ManagementCompanyNotificationsSettings']
});

const managementCompanySettingsApi = apiWithTags.injectEndpoints({
	tagTypes: ['ManagementCompanyNotificationsSettings'],
	endpoints: (build) => ({
		getManagementNotificationsSettings: build.query({
			query: (managementCompanyId) => ({
				url: `/flex/management-companies/${managementCompanyId}/settings/notifications`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['ManagementCompanyNotificationsSettings']
		}),
		updateManagementNotificationsSettings: build.mutation({
			query: ({ managementCompanyId, body }) => ({
				url: `/flex/management-companies/${managementCompanyId}/settings/notifications`,
				method: 'PUT',
				body,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			invalidatesTags: ['ManagementCompanyNotificationsSettings']
		})
	})
});

export const {
	useGetManagementNotificationsSettingsQuery,
	useUpdateManagementNotificationsSettingsMutation
} = managementCompanySettingsApi;
